<div class="sidebar">
    <div
        [class.sidebar-collapsed]="!isSidebarExpanded"
        [class.sidebar-expanded]="isSidebarExpanded"
        class="sidebar-container d-none d-lg-block py-3"
        id="sidebar-container"
    >
        <!-- logo -->
        <div
            [ngClass]="{ 'ms-4': isSidebarExpanded, 'justify-content-center': !isSidebarExpanded }"
            class="d-flex mb-4 mt-1"
        >
            @if (isSidebarExpanded && (tenantId$ | async) === null) {
                <img alt="" class="logo-expanded" src="/assets/img/common/logo-lg.png" />
            }
            @if (!isSidebarExpanded && (tenantId$ | async) === null) {
                <img alt="" class="logo-collapsed" src="/assets/img/common/logo-sm.png" />
            }
            @if (logoUrl) {
                @if (isSidebarExpanded && (tenantId$ | async)) {
                    <img alt="" class="logo-expanded" [src]="logoUrl" />
                }
                @if (!isSidebarExpanded && (tenantId$ | async)) {
                    <img alt="" class="logo-collapsed" [src]="logoUrl" />
                }
            } @else {
                @if (isSidebarExpanded && (tenantId$ | async)) {
                    <span class="logo-expanded text-white fw-medium text-uppercase h6">{{ companyName }}</span>
                }
                @if (!isSidebarExpanded && (tenantId$ | async)) {
                    <span class="logo-collapsed text-white fw-medium text-uppercase text-small">{{
                        companyName.substring(0, 2)
                    }}</span>
                }
            }
        </div>
        <!-- //logo -->

        <!-- List Group -->
        <ul class="list-group mt-2">
            @for (
                item of (userRole$ | async) === userRoleType.APPLICATION_VIEWER ||
                (userRole$ | async) === userRoleType.TENANT_VIEWER
                    ? viewRoutes
                    : (tenantId$ | async) === null
                      ? tenantManageRoutes
                      : adminRoutes;
                track item.name
            ) {
                <div>
                    <a
                        [routerLink]="item.route"
                        class="list-group-item"
                        [ngClass]="{ 'list-group dropdown': item.hasSubMenu }"
                        routerLinkActive="active"
                    >
                        <div
                            [ngClass]="{ 'ps-2': isSidebarExpanded, 'justify-content-center': !isSidebarExpanded }"
                            class="d-flex align-self-center"
                        >
                            <i [ngClass]="item.icon" class="bi"></i>
                            <span class="menu-collapsed">{{ item.name }}</span>
                        </div>
                    </a>
                    <!-- //List Group - subMenu -->
                    @if (item.hasSubMenu) {
                        <div class="mt-0">
                            @for (items of item.subMenu; track items.name) {
                                <a class="sub-item" routerLinkActive="active" [routerLink]="items.route">
                                    <div class="box" routerLinkActive="active">
                                        <div
                                            [ngClass]="{
                                                'ps-2': isSidebarExpanded,
                                                'justify-content-center': !isSidebarExpanded
                                            }"
                                            class="d-flex align-self-center items"
                                        >
                                            <i [ngClass]="items.icon" class="bi"></i>
                                            <span class="menu-collapsed">{{ items.name }}</span>
                                        </div>
                                    </div>
                                </a>
                            }
                        </div>
                    }
                    <!-- //List Group - subMenu-->
                </div>
            }
            <!-- //List Group -->
        </ul>
    </div>
</div>
